import { Navigate, useParams } from 'react-router-dom';

import { getRouteCatalog } from 'shared/const/router';

/**
 * Redirects legacy `/properties/:propertyId/catalog/*` bookmarks
 * to `/catalog/:propertyId/*`.
 */
export const LegacyCatalogRedirect = () => {
    const params = useParams();
    const propertyId = params.propertyId;
    const rest = params['*'];

    if (!propertyId) {
        return <Navigate to="/catalog" replace />;
    }

    const suffix = rest ? `/${rest}` : '';
    return <Navigate to={`${getRouteCatalog(propertyId)}${suffix}`} replace />;
};
